import React, { useContext, useState } from "react";
import ReactDOM from "react-dom";
import { useEffect } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import AuthService from "../../services/auth.service";
import moment from "moment";
import { API_URL } from "../../utilities/url";
import CryptoJS from "crypto-js";
import storage from "../../services/storage";
import DashboardPanel from "./component/dashboardPanel";
import { FiEye } from "react-icons/fi";
import { FaTrash } from "react-icons/fa";
import { WorkspaceContext } from "../../provider/workspaceContext";
import authService from "../../services/auth.service";

var $ = require("jquery");

const Dashboard = () => {
  const { workspace, setWorkspace } = useContext(WorkspaceContext);
  const [isWorkspaceLoaded, setIsWorkspaceLoaded] = useState(false);

  useEffect(() => {
    const encryptedWS = storage.get("wrs");
    if (encryptedWS) {
      try {
        const decryptWS = CryptoJS.AES.decrypt(encryptedWS, "wrs").toString(
          CryptoJS.enc.Utf8
        );

        if (decryptWS) {
          const parsedWorkspace = JSON.parse(decryptWS);
          setWorkspace(parsedWorkspace);
        } else {
          console.warn("Dekripsi berhasil tetapi hasilnya kosong.");
        }
      } catch (error) {
        if (error.response.data.message) {
          authService.logout();
        }
      }
    } else {
      console.warn("Tidak ada data workspace terenkripsi.");
    }

    setIsWorkspaceLoaded(true);
  }, [setWorkspace]);

  useEffect(() => {
    if (isWorkspaceLoaded && workspace) {
      getDataTable();
    }
  }, [isWorkspaceLoaded, workspace]);

  const getDataTable = () => {
    $("#datatables-reponsive").DataTable({
      dom:
        "<'row'<'col-sm-6'l><'col-sm-6'B>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row'<'col-sm-5'i><'col-sm-7'p>>",
      processing: true,
      serverSide: true,
      bDestroy: true,
      ajax: {
        url: API_URL + "list-table-broadcast",
        data: function (data) {
          data.idt_user_workspace = workspace;
          data.status = "Ongoing";
        },
        type: "post",
        headers: {
          Authorization: `Bearer ${storage.get("access_token")}`,
        },
        error: function (xhr, error, code) {},
      },
      columnDefs: [
        {
          targets: [5],
          createdCell: function (td) {
            td.classList.add("dt-right");
          },
        },
        {
          className: "dt-center",
          targets: [6],
        },
        {
          className: "dt-center",
          targets: 7,
          createdCell: (td, cellData, rowData, row, col) =>
            ReactDOM.render(
              <div className="d-grid gap-2 d-md-flex justify-content-md">
                <a
                  // onClick={() => editTable(cellData)}
                  className="btn btn-sm btn-primary btn-rounded"
                  title="Webchat View"
                >
                  <FiEye size={14} />
                </a>
                <a
                  // onClick={() => deleteTable(cellData)}
                  className="btn btn-sm btn-tertiary btn-rounded"
                  title="Delete"
                >
                  <FaTrash />
                </a>
                {/* <a
                  onClick={() =>
                    navigate(
                      `/broadcast/detail/${rowData.idt_broadcast_campaign}`
                    )
                  }
                  className="btn btn-sm btn-info btn-rounded"
                  title="Settings"
                >
                  <FaCog size={14} />
                </a> */}
              </div>,
              td
            ),
        },
      ],
      columns: [
        {
          data: "ts_created",
          render: function (data, type, row) {
            var data = moment(data).format("DD-MM-YYYY");

            return data;
          },
        },
        { data: "name" },
        { data: "content_name" },
        { data: "channel" },
        { data: "devices_name" },
        { data: "contacts" },
        {
          data: "is_active",
          render: function (data, type, row) {
            if (data === "Y") return "Active";
            else return "Not Active";
          },
        },
        { data: "idt_broadcast_campaign" },
      ],
      initComplete: function () {
        var api = this.api();
        $("#search")
          .off(".DT")
          .on("keyup.DT", function (e) {
            api.search(this.value).draw();
          });
      },
    });
  };

  return (
    <div className="container-fluid p-0">
      <div className="row mb-2 mb-xl-3">
        <h3>Dashboard</h3>
      </div>
      <DashboardPanel />
      <div className="card flex-fill rounded-4 shadow-lg">
        <div className="card-header rounded-4">
          <div className="card-actions float-end">
            <div className="dropdown position-relative">
              <a href="#" data-bs-toggle="dropdown" data-bs-display="static">
                {/* <MoreHorizontal className="align-middle" /> */}
              </a>

              <div className="dropdown-menu dropdown-menu-end">
                <a className="dropdown-item" href="#">
                  Action
                </a>
                <a className="dropdown-item" href="#">
                  Another action
                </a>
                <a className="dropdown-item" href="#">
                  Something else here
                </a>
              </div>
            </div>
          </div>
          <h5 className="card-title mb-0">
            <span className="text-primary-2">Ongoing</span>{" "}
            <span className="text-orange">Broadcast List</span>
          </h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table
              id="datatables-reponsive"
              className="table table-striped table-bordered table-custome"
            >
              <thead>
                <tr className="text-white">
                  <th>Created At</th>
                  <th>Broadcast Name</th>
                  <th>Content Name</th>
                  <th>Channel</th>
                  <th>Device</th>
                  <th>Total Contact</th>
                  {/* <th>Start</th>
                    <th>End</th> */}
                  <th>Status</th>
                  {/* <th>PIC</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
